import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Meus clientes sempre pediam desconto e eu dava para não perder a venda, o método mudou a forma como os meus produtos são vistos, comecei a vender mais e sem desconto!',
  author: 'Carla',
  role: 'Ateliê de Festas',
  image: 'https://cdn.magicpatterns.com/uploads/x8JRNoVSVV832Z9HVXeXKH/Gemini_Generated_Image_p2l30jp2l30jp2l3.png'
}, {
  quote: 'O guia me mostrou que é tudo questão de detalhe. Lucrei 3x mais no último pedido.',
  author: 'Patrícia',
  role: 'Doceira',
  image: 'https://cdn.magicpatterns.com/uploads/dfz9dsdQZDjB5Hb8i2pBpL/Gemini_Generated_Image_vmykbevmykbevmyk.png'
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const itemWidth = container.offsetWidth;
      const index = Math.round(scrollLeft / itemWidth);
      setCurrentIndex(Math.min(index, testimonials.length - 1));
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="py-8 md:py-12 bg-stone-50 overflow-hidden" data-id="element-369">
      <div className="max-w-7xl mx-auto px-6" data-id="element-370">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-371">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-900" data-id="element-372">
            Quem começou a usar já está comentando
          </h2>
        </motion.div>

        <div ref={scrollContainerRef} className="flex gap-6 overflow-x-auto pb-8 snap-x snap-mandatory scrollbar-hide" data-id="element-373">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="flex-shrink-0 w-[85vw] md:w-[400px] bg-white p-6 md:p-8 rounded-2xl border border-stone-100 snap-center shadow-sm" data-id="element-374">
              <Quote className="w-8 h-8 text-brand-200 mb-4" data-id="element-375" />

              <p className="text-stone-700 text-sm md:text-base leading-relaxed mb-6 font-medium" data-id="element-376">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-377">
                {testimonial.image && <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border-2 border-brand-100" data-id="element-378">
                    <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-379" />
                  </div>}
                <div data-id="element-380">
                  <p className="font-bold text-stone-900 text-sm md:text-base" data-id="element-381">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-stone-500 uppercase tracking-wide mt-1" data-id="element-382">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-383">
          {testimonials.map((_, index) => <button key={index} onClick={() => {
          const container = scrollContainerRef.current;
          if (container) {
            const itemWidth = container.offsetWidth;
            container.scrollTo({
              left: itemWidth * index,
              behavior: 'smooth'
            });
          }
        }} className={`w-2 h-2 rounded-full transition-all duration-300 ${currentIndex === index ? 'bg-brand-500 w-6' : 'bg-stone-300 hover:bg-stone-400'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-384" />)}
        </div>
      </div>

      <style jsx data-id="element-385">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>;
}